import { NetworkService } from '../services'
import { BaseTransport } from '../transports'
import LivePricingResponseTransport, {
    ComboLivePricingParamsTransport,
    ComboLivePricingResponseTransport,
    LivePricingParamsTransport,
} from '../transports/live-pricing-transport'

class PricingClient {
    public getLivePrices({
        params,
    }: {
        params: LivePricingParamsTransport
    }): Promise<BaseTransport<LivePricingResponseTransport>> {
        return NetworkService.get({
            url: `/api/v1/prices/listings/${params.listingId}/live`,
            params,
        })
    }

    public getComboLivePrices({
        params,
    }: {
        params: ComboLivePricingParamsTransport
    }): Promise<BaseTransport<ComboLivePricingResponseTransport>> {
        return NetworkService.get({
            url: `/api/v1/prices/listings/live?listingIds=${encodeURIComponent(params.listingIds)}&arrival=${
                params.arrival
            }&departure=${params.departure}&adults=${params.adults}&childrenAges=${encodeURIComponent(
                params.childrenAges,
            )}&pets=${params.pets}`,
        })
    }
}

export default new PricingClient()
